import { render, staticRenderFns } from "./video-links-card.vue?vue&type=template&id=3d7843d7&scoped=true&"
import script from "./video-links-card.vue?vue&type=script&lang=js&"
export * from "./video-links-card.vue?vue&type=script&lang=js&"
import style0 from "./video-links-card.vue?vue&type=style&index=0&id=3d7843d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7843d7",
  null
  
)

export default component.exports